import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { Layout } from "../../ui/layout"
import { Banner } from "../../ui/organisms/banner"
import { CustomHorizontalTab } from "../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../ui/organisms/navbar/dto"
import { SchedaCalcoloForms } from "./forms"
import { SchedaCalcoloList } from "./list"
import { SchedaCalcoloPrint } from "./print"
import { setOnEdit } from "./slice"

export function SchedaCalcoloAdmin() {
    const dispatch = useAppDispatch()
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const serviceAndBillingState = useAppSelector(state => state.billingAndServiceType)
    const [showError, setShowError] = useState<boolean>(false)

    useEffect(() => {
        if (serviceAndBillingState.billingWorksheetCreationStatus === 'failed') {
            setShowError(true)
        }
    }, [serviceAndBillingState.billingWorksheetCreationStatus])

    return (
        <Layout
            menuItem={MenuItems.STRUMENTI}
            breadcrumbItems={['Strumenti', 'Gestione Scheda di Calcolo']}
            noPaddingLat
            headerLabel="Gestione Scheda di Calcolo"
        >
            <CustomHorizontalTab
                selectedIndex={selectedTab}
                onTabClick={(index) => {
                    setSelectedTab(index)
                    if (index === 1) {
                        dispatch(setOnEdit(false))
                    }
                }}
            >
                <div>Lista</div>
                <div>Creazione/Modifica</div>
                <div>Stampa</div>
            </CustomHorizontalTab>
            {
                showError &&
                <Banner
                    type="error"
                    visible={serviceAndBillingState.billingWorksheetCreationStatus === 'failed'}
                    label={"Si è verificato un errore durante la creazione della scheda di calcolo"}
                    closeAction={function (): void {
                        setShowError(false)
                    }}
                />

            }
            <div className="fieldset bg-brandPrimary-200" style={{ padding: '12px 24px 24px 24px' }}>
                {
                    selectedTab === 0 &&
                    <SchedaCalcoloList />
                }
                {
                    selectedTab === 1 &&
                    <SchedaCalcoloForms />
                }
                {
                    selectedTab === 2 &&
                    <SchedaCalcoloPrint />
                }
            </div>
        </Layout>
    )
}